<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Edit Group Info</p-heading>

  <form class="form" [id]="formId" [formGroup]="form" (ngSubmit)="submit()">
    <p-text-field-wrapper
      *ngrxLet="form.controls.name as control"
      [label]="'Group Name'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <input type="text" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>

    <p-select-wrapper
      *ngrxLet="form.controls.type as control"
      [filter]="true"
      [label]="'Group Type'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <select [attr.required]="true" [formControl]="control">
        <option *ngFor="let type of groupTypes" [value]="type">
          {{ groupTypeTranslation[type] | transloco }}
        </option>
      </select>
    </p-select-wrapper>
  </form>

  <p-button-group slot="footer">
    <p-button [form]="formId" [loading]="(submitting$ | async) ?? false" [type]="'submit'">
      Save
    </p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
